import React from "react";
import { Link, useNavigate } from "react-router-dom";
import scrollToTop from '../Components/ScrollToTop'
// import house_sale from "../images/house-illustration.svg"
import completed_illustration from "../images/completed_illustration.png"

function Thankyou() {
    const navigate = useNavigate();


    const handleGoBack = () => {
        navigate(-1);
        setTimeout(() => window.scrollTo(0, 0), 100);
    };


    return (
        <>
            <div className="max-w-2xl mx-auto flex flex-col justify-center items-center mt-5 pb-12">
                <img src={completed_illustration} alt="house_illustration" className="w-[50%] h-fit mt-3 mb-12" />

                <div className="px-8 sm:px-0 text-center">
                    {/* <h1 className="font-noto font-bold text-[40px] leading-[90px]  sm:text-[80px] ">Thank You for your Enquiry!</h1> */}
                    {/* <p className="text-[22px] w-3/4 mx-auto sm:w-full font-[Lato] mt-10">Our team will get back to you soon...</p> */}
                    <h1 className="font-noto font-bold text-[38px] md:text-[50px]">Thank You for your Enquiry!</h1>
                    <p className='font-alibaba text-[20px] text-[#5F5D5E] mt-6 sm:text-[22px] sm:mt-10'>Our team will get back to you soon...</p>
                    <button onClick={handleGoBack} className="w-full  bg-yellow font-[lato] text-[#191915] text-center px-[30px] py-[15px] text-[14px] font-semibold leading-[16px] uppercase tracking-[1.8px] mt-12">GO BACK</button>

                </div>
            </div>
        </>
    )
}


export default Thankyou;
